import { IconCurrencyBaht } from '@tabler/icons-react';
import { memo } from 'react';

interface SpendRateProps {
    label?: string;
    value?: number;
    currencyIcon?: React.ReactNode;
    perLabel?: string;
}

function SpendRate({
    label = 'Rolling average',
    value = 1024.0,
    perLabel = 'day',
    currencyIcon = <IconCurrencyBaht size={16} stroke={2.7} className="mb-0.5" />,
}: SpendRateProps) {
    return (
        <div className="w-full flex flex-col justify-start items-start gap-1">
            <h3 className="text-sm text-fg/68">{label}</h3>
            <div className="flex items-center gap-1.5 font-bold">
                <span className="text-base">
                    {value?.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}
                </span>
                {currencyIcon}
                <span className="relative top-0.5 font-weight-400 text-[12px] text-fg/70">
                    / {perLabel}
                </span>
            </div>
        </div>
    );
}

export default memo(SpendRate);
